
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_USER_PUBLIC_INFO from "@/apollo/user/GetContractorPublicInfoForAdmin.gql";

  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";
  import CardInfoChip from "@/components/card/CardInfoChip.vue";
  import AddContractorToCompany from "@/components/contractors/AddContractorToCompanyMarketplace.vue";
  import ContractorAbout from "@/components/contractors/ContractorAbout.vue";
  import ContractorFullInformationLink from "@/components/contractors/ContractorFullInformationLink.vue";
  import RouteNames from "@/entities/RouteNames";
  import { Company, User } from "@/generated/graphql";
  import Roles from "@/entities/Roles";

  @Component({
    components: {
      AddContractorToCompany,
      LoadingOverlay,
      ContractorAbout,
      CardInfoChip,
      ContractorFullInformationLink,
    },
    apollo: {
      contractorUser: {
        query: GET_USER_PUBLIC_INFO,
        variables() {
          return {
            id: this.contractorUserId,
            companyId: this.company.id,
          };
        },
        update: (data) => data.user_by_pk,
      },
    },
  })
  export default class ContractorAboutForAdmin extends Vue {
    @Prop({ type: Object, required: true }) readonly company!: Company;
    @Prop({ type: String, required: true }) readonly adminUserId!: string;
    @Prop({ type: Object, required: true }) readonly currentUser!: User;
    @Prop({ type: Boolean, required: true }) readonly hasAllResourceAccess!: boolean;
    @Prop({ type: Boolean, required: false, default: true })
  readonly isAdmin!: boolean;
    @Prop({ type: String, required: true }) readonly contractorUserId!: string;

    roles = Roles;
    contractorUser?: User;
    addedContractorId: string = "";

    addedToCompany: boolean = false;

    onAddToCompany(contractorId: string) {
      this.addedToCompany = true;
      this.addedContractorId = contractorId;
      const userId = JSON.parse(sessionStorage.getItem("marketPlaceUserID"));
        this.$router.push({
       name: RouteNames.MARKETPLACE_CONTRACTORS,
      });
    }

    get isInCompany(): boolean {
      const contracts = this.contractorUser?.contracts;
      if (!contracts) {
        return false;
      }

      const contractorInCompany = contracts.length > 0;
      const contractorApproved = contracts[0]?.approved;
      const contractorDeleted = contracts[0]?.deleted;

      return this.addedToCompany || (contractorInCompany && contractorApproved && !contractorDeleted);
    }

    get contractorId(): string {
      return this.contractorUser?.contracts[0]?.id || this.addedContractorId;
    }

  }
